"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.fetchSubnavConfig = exports.fetchMockSubCatData = exports.fetchSubCatData = exports.fetchCatalog = void 0;

require("core-js/modules/es6.regexp.replace");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.string.includes");

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

require("core-js/modules/es7.array.includes");

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _objectSpread6 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _helperUtil = require("./util/helperUtil");

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _Logger = _interopRequireDefault(require("./util/Logger"));

var _constants = require("../constants");

var _uigCdnLibraries = require("@sfly/uig-cdn-libraries");

var defaultHost = "https://api2.".concat((0, _uigCurrentEnvironmentUtil.getBaseHostname)());
var linkPosition = 0;
var loggerInstance = new _Logger.default('fetchCatalogs');

function productCatalogUrl(_ref) {
  var hostKey = _ref.hostKey,
      contextName = _ref.contextName;
  var host = hostKey || defaultHost;

  if (!contextName) {
    loggerInstance.error("missing: contextName", "productCatalogUrl", {
      error: '"missing: contextName"'
    });
    throw new Error("missing: contextName");
  }

  return "".concat(host, "/v1/product-catalog/product/catalog/v1/productCategories/").concat(contextName, "?showLinkedCategories=false&showUnavailableCategories=true");
}

var fetchCatalog = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(contextKey, dcSubnavConfig) {
    var URL, categories, catCodeList;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0, _uigCdnLibraries.polyfillFetch)();

          case 3:
            URL = productCatalogUrl({
              contextName: contextKey
            });
            _context.next = 6;
            return window.fetch(URL, (0, _helperUtil.getSearchConfig)()).then(function (res) {
              return res.json();
            });

          case 6:
            categories = _context.sent;

            if (dcSubnavConfig) {
              catCodeList = []; // handle overriding cat attributes, hiding category if any

              categories = categories.map(function (category) {
                catCodeList.push(category.code);
                return (0, _objectSpread6.default)({}, category, {}, dcSubnavConfig[category.code]);
              }); // Add new cat to the list if any

              (0, _keys.default)(dcSubnavConfig).map(function (code) {
                if (!catCodeList.includes(code)) {
                  categories.push((0, _objectSpread6.default)({
                    code: code
                  }, dcSubnavConfig[code]));
                }
              });
              categories = categories.filter(function (category) {
                return !category.removeCategory;
              });
            }

            return _context.abrupt("return", categories);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            loggerInstance.error('Error: while fetching catalog', 'fetchCatalog', _context.t0);
            throw _context.t0;

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));

  return function fetchCatalog(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.fetchCatalog = fetchCatalog;

function getBatchURL(dcIds, url) {
  var newDCURL = "//api2.".concat((0, _uigCurrentEnvironmentUtil.getBaseHostname)(), "/v1/services-dynamic-content/v1/dynamic-content/batch?contentSpaces=");
  var batchURL = url && url !== '' ? url : newDCURL;
  batchURL += dcIds;
  return batchURL;
}

function addDataLinkToDC(dcContent, catName) {
  if (!document) {
    return dcContent;
  }

  var tempHTMLDoc = document.implementation.createHTMLDocument('');
  var tempDiv = tempHTMLDoc.createElement('div');
  tempDiv.innerHTML = dcContent;
  var lis = tempDiv.getElementsByTagName('li');

  for (var i = 0; i < lis.length; i++) {
    var subDataLinkId = lis[i].innerText.trim();
    var aTagElements = lis[i].querySelector('a');

    if (aTagElements) {
      var imgElement = aTagElements.querySelector('img');

      if (imgElement) {
        if (!imgElement.getAttribute('alt')) {
          var altText = '';
          var href = aTagElements.getAttribute('href');

          if (href) {
            altText = href.split('/').join(' ').trim();
          }

          imgElement.setAttribute('alt', altText);
        }

        subDataLinkId = "".concat(imgElement.getAttribute('alt'), "/img");
      }

      aTagElements.setAttribute('data-link-id', "".concat(catName, "/").concat(subDataLinkId));
      aTagElements.setAttribute('data-link-module', 'global-header');
      aTagElements.setAttribute('data-link-module-type', 'category-nav');
      aTagElements.setAttribute('data-link-module-position', 'none');
      aTagElements.setAttribute('data-link-position', linkPosition++);
    }
  }

  linkPosition = 0;
  return tempDiv.innerHTML.toString();
}

var batchDCIds = function batchDCIds(categories) {
  var allCatDynamicContentIdsArr = [];
  var catDCIdsMap = {};
  categories.map(function (category) {
    var catDynamicIds = category.dynamicContentIds;
    var dcsArr = [];
    catDynamicIds && (0, _keys.default)(catDynamicIds).map(function (key) {
      if (catDynamicIds[key]) {
        catDynamicIds[key].map(function (dcId) {
          allCatDynamicContentIdsArr.push(dcId);
          dcsArr.push(dcId);
        });
      }

      catDCIdsMap[category.code] = {
        dcsArr: dcsArr,
        name: category.name
      };
    });
  });
  return {
    catDCIdsMap: catDCIdsMap,
    allCatDynamicContentIdsArr: allCatDynamicContentIdsArr
  };
};

var makeGetCall = function makeGetCall(batchURL) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new _promise.default(function (resolve, reject) {
    fetch(batchURL, config).then(function (res) {
      resolve(res);
    }).catch(function (error) {
      loggerInstance.error('Error: while making get call', 'makeGetCall', error);
      reject(error);
    });
  });
};

var createDynamicContentsMap = function createDynamicContentsMap(dynamicContents) {
  return dynamicContents.reduce(function (acc, element) {
    return (0, _objectSpread6.default)({}, acc, (0, _defineProperty2.default)({}, element.contentSpace, element.dynamicContent));
  }, {});
};

var fetchSubCatData = function fetchSubCatData(categories, brandType) {
  var _batchDCIds = batchDCIds(categories),
      catDCIdsMap = _batchDCIds.catDCIdsMap,
      allCatDynamicContentIdsArr = _batchDCIds.allCatDynamicContentIdsArr;

  return new _promise.default(function (resolve, reject) {
    var batchURL = getBatchURL(allCatDynamicContentIdsArr.toString());
    var config = {
      headers: {
        'SFLY-ApiKey': (0, _helperUtil.getEnvPrefix)() !== '' ? _constants.DC_SERVICE_API_KEYS.NON_PROD : _constants.DC_SERVICE_API_KEYS.PROD
      }
    };
    return makeGetCall(batchURL, config).then(function (res) {
      if (res) {
        res.json().then(function (data) {
          resolve(createDynamicContentsMap(data.dynamicContents || []));
        });
      }
    }).catch(function (e) {
      loggerInstance.error('Error: while making get call to fetch subcategories', 'fetchSubCatData', e);
      reject(e);
    });
  }).then(function (dcResponse) {
    var formattedDcResponse = {};
    (0, _keys.default)(catDCIdsMap).map(function (catCode) {
      var catName = catDCIdsMap[catCode].name;
      formattedDcResponse[catCode] = '';
      var dcContent = '';
      catDCIdsMap[catCode].dcsArr.map(function (dcId) {
        dcContent += dcResponse[dcId] ? addDataLinkToDC(dcResponse[dcId], catName) : '';
      });
      formattedDcResponse[catCode] = dcContent;
    });
    return formattedDcResponse;
  });
};

exports.fetchSubCatData = fetchSubCatData;

var fetchMockSubCatData = function fetchMockSubCatData(categories, brandType) {
  var dcMapper = {};
  categories.map(function (category) {
    var catId = category.code;
    dcMapper[catId] = '';
    var mergedDCContent = '';
    var catDynamicIds = category.dynamicContentIds;
    catDynamicIds && (0, _keys.default)(catDynamicIds).map(function (dcIds) {
      catDynamicIds[dcIds].map(function (dcId) {
        //let { dcContent } = require("../mocks/" + dcId);
        //let dcContent = DCMAPPING[dcId];
        var dcContent = '';
        mergedDCContent += addDataLinkToDC(dcContent, category.name);
      });
    });
    dcMapper[catId] = mergedDCContent;
  });
  return dcMapper;
};

exports.fetchMockSubCatData = fetchMockSubCatData;

var convertToJSON = function convertToJSON(response) {
  //strip out the wrapper added by comet
  var stringJSON = response.replace('<!-- HTML Content Wrapper -->', '');
  stringJSON = stringJSON.replace('<!-- /HTML Content Wrapper -->', ''); //convert the string to JSON object

  try {
    return JSON.parse(JSON.parse(stringJSON).dynamicContent);
  } catch (e) {
    loggerInstance.error('Unable to create a JSON object using the string provided. ', 'convertToJSON', e);
    return undefined;
  }
};

var fetchSubnavConfig = function fetchSubnavConfig(brandType) {
  var url = "".concat(defaultHost, "/v1/services-dynamic-content/v1/dynamic-content?contentSpace=subnav_config_").concat(brandType);
  return makeGetCall(url).then(function (res) {
    return res.text().then(function (data) {
      return convertToJSON(data);
    });
  }).catch(function (e) {
    loggerInstance.error('Error: while making get call to fetch subnav config', 'fetchSubnavConfig', e);
    return null;
  });
};

exports.fetchSubnavConfig = fetchSubnavConfig;